import React from "react";
import { Button, Table } from "react-bootstrap";
import AnalyticsStatHero from "./AnalyticsStatHero";
import { formatInr } from "../../utils/financeFormat";
import TableTotalAmount, { ANALYTICS_TABLE_TOTAL_ROW_CLASS } from "./TableTotalAmount";

export default function MonthlyCashSummaryTab({ periodMonth, cashDto, onRefresh, busy }) {
  const entries = cashDto?.entries || [];
  const total = cashDto?.totalCashRupee ?? 0;

  return (
    <>
      <AnalyticsStatHero
        label={`Monthly cash total — ${periodMonth}`}
        amountRupee={total}
        valueClassName="text-warning"
        meta={
          <div>
            All cash entries across modules roll up here for profit and trends.
          </div>
        }
      />
      <Button size="sm" variant="outline-light" className="mb-3" onClick={onRefresh} disabled={busy}>
        Refresh cash summary
      </Button>
      <Table striped bordered hover size="sm" variant="dark" responsive className="mb-0">
        <thead>
          <tr>
            <th>Module</th>
            <th className="text-end">Cash ₹</th>
          </tr>
        </thead>
        <tbody>
          {entries.length === 0 ? (
            <tr>
              <td colSpan={2} className="text-secondary small">
                No cash amounts saved yet — use cash fields on Coal, Dairy, Meat, Gas, etc.
              </td>
            </tr>
          ) : (
            <>
              {entries.map((e) => (
                <tr key={`cash-${e.slotId}`}>
                  <td>{e.label || e.slotId}</td>
                  <td className="text-end text-warning">{formatInr(e.cashRupee)}</td>
                </tr>
              ))}
              <tr className={ANALYTICS_TABLE_TOTAL_ROW_CLASS}>
                <td>Total cash this month</td>
                <td className="text-end fs-6">
                  <TableTotalAmount amount={total} toneClass="text-warning" />
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>
    </>
  );
}
